export function requestMicrophonePermissionIfNeeded() {
  if (!navigator.permissions) {
    // Permissions API not supported, just request permission
    console.error('Permissions API not supported, requesting microphone permission directly.');
    return requestMicrophonePermission();
  }

  return navigator.permissions.query({ name: 'microphone' })
    .then(status => {
      console.log('Microphone permission status:', status.state);
      if (status.state === 'granted') {
        return requestMicrophonePermission();
      } else if (status.state === 'prompt') {
        return requestMicrophonePermission();
      } else {
        console.warn('Permission denied');
        return false;
      }
    })
    .catch(() => requestMicrophonePermission());
}

export function requestMicrophonePermission() {
  return navigator.mediaDevices.getUserMedia({ audio: true })
    .then(stream => {
      stream.getTracks().forEach(track => track.stop());
      return true;
    })
    .catch(err => {
      console.error('Error requesting microphone permission:', err);
      return false;
    });
}